import { WrappedError } from './wrapped-error';

/**
 * Base class to be used for known errors, these have special handlers in the application.
 *
 * @deprecated use WrappedError
 */
export abstract class KnownError<OrigErr = unknown> extends WrappedError<OrigErr> {
}
